import { CheckOutlined, Close } from "@mui/icons-material";
import { Button, ButtonOwnProps, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { ReactNode } from "react";

export function ConfirmationDialog({
  cancelMessage,
  confirmMessage,
  handleCancel,
  handleConfirm,
  isOpen,
  message,
  title,
  handleClose,
  buttonsDisabled = false,
  buttonColor = "primary",
}: {
  cancelMessage: string;
  confirmMessage: string;
  handleCancel: any;
  handleConfirm: any;
  isOpen: boolean;
  message: ReactNode;
  title: string;
  handleClose: any;
  buttonsDisabled?: boolean;
  buttonColor?: ButtonOwnProps["color"];
}) {
  return (
    <Dialog onClose={handleClose || handleCancel} open={isOpen} data-test={`confirmdialog-${title}`}>
      <DialogTitle data-test={`confirmdialog-title-${title}`}>{title}</DialogTitle>
      <DialogContent data-test={`confirmdialog-content-${title}`}>{message}</DialogContent>
      <DialogActions data-test={`confirmdialog-actions-${title}`} sx={{ pb: 2, px: 2 }}>
        <Button
          data-test={`confirmdialog-okay-${title}`}
          onClick={handleConfirm}
          variant="contained"
          color={buttonColor}
          endIcon={<CheckOutlined />}
          disabled={buttonsDisabled}
        >
          {confirmMessage || ""}
        </Button>
        <Button
          data-test={`confirmdialog-cancel-${title}`}
          onClick={handleCancel}
          variant="outlined"
          color="inherit"
          endIcon={<Close />}
          disabled={buttonsDisabled}
        >
          {cancelMessage || ""}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
